module.exports = __webpack_public_path__ + "img/Distribution-of-Packages-by-Continent-300x257.a789783b.png";